import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Checkbox } from 'primereact/checkbox';
import React, { Fragment, useState, useEffect } from 'react';

export default function BaseScopeParametersGrid({
  parameters,
  customScopesParameters,
  isEditMode,
  isCreateMode,
  selectHandler,
  deselectHandler,
}) {
  const [selectedRows, setSelectedRows] = useState([]);

  // Initialize selected rows based on customScopesParameters
  useEffect(() => {
    if (isEditMode || isCreateMode) {
      const selected = parameters.filter((param) => {
        return customScopesParameters.some(
          (customParam) => customParam.name === param.name
        );
      });
      setSelectedRows(selected);
    }
  }, [parameters, customScopesParameters, isEditMode, isCreateMode]);

  // Handle selection changes
  const onSelectionChange = (e) => {
    const { value } = e;
    setSelectedRows(value);

    // Handle newly selected rows
    const previouslySelected = selectedRows || [];
    const newlySelected = value.filter((row) => {
      return !previouslySelected.some((prevRow) => prevRow.name === row.name);
    });

    if (newlySelected.length > 0) {
      // Simulate the row selection event for selectHandler
      selectHandler({
        data: newlySelected.length === 1 ? newlySelected[0] : newlySelected,
      });
    }

    // Handle deselected rows
    const deselected = previouslySelected.filter((row) => {
      return !value.some((selectedRow) => selectedRow.name === row.name);
    });

    if (deselected.length > 0) {
      // Simulate the row deselection event for deselectHandler
      deselectHandler({
        data: deselected.length === 1 ? deselected[0] : deselected,
        isHeaderCheckboxClicked: false,
      });
    }
  };

  // Custom checkbox selection template
  const selectionTemplate = (rowData) => {
    const isSelected =
      selectedRows?.some((row) => row.name === rowData.name) || false;

    return (
      <Checkbox
        checked={isSelected}
        onChange={() => {
          const newSelection = isSelected
            ? selectedRows.filter((row) => row.name !== rowData.name)
            : [...(selectedRows || []), rowData];

          onSelectionChange({ value: newSelection });
        }}
      />
    );
  };

  return isEditMode || isCreateMode ? (
    <Fragment>
      <label htmlFor='base_scopes_parameters'>BaseScope Parameters</label>
      <DataTable
        value={parameters}
        id='base_scopes_parameters'
        scrollable
        scrollHeight='200px'
        selection={selectedRows}
        onSelectionChange={onSelectionChange}
        dataKey='name'
        className='parameter-selection-table'
      >
        <Column
          selectionMode='multiple'
          body={selectionTemplate}
          style={{ width: '50px' }}
        />
        <Column field='name' header='Key' style={{ width: '40%' }} />
        <Column field='value' header='Value' style={{ width: '50%' }} />
      </DataTable>
    </Fragment>
  ) : (
    <Fragment>
      <label htmlFor='base_scopes_parameters_static'>
        BaseScope Parameters
      </label>
      <DataTable
        value={parameters}
        id='base_scopes_parameters_static'
        scrollable
        scrollHeight='200px'
      >
        <Column field='name' header='Key' style={{ width: '40%' }} />
        <Column field='value' header='Value' style={{ width: '60%' }} />
      </DataTable>
    </Fragment>
  );
}
